import { useState, useEffect, useMemo } from 'react';
import { token } from '@atlaskit/tokens';
import { trackFetchErrors } from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { Project } from '../../../../common/types.tsx';

const mappings = {
	'project_avatar_alien.svg': token('color.background.accent.teal.subtler'),
	'project_avatar_cloud.svg': token('color.background.accent.blue.subtler'),
	'project_avatar_code.svg': token('color.background.accent.red.subtler'),
	'project_avatar_coffee.svg': token('color.background.accent.teal.subtler'),
	'project_avatar_design.svg': token('color.background.accent.orange.subtler'),
	'project_avatar_disc.svg': token('color.background.accent.red.subtler'),
	'project_avatar_drill.svg': token('color.background.accent.purple.subtler'),
	'project_avatar_food.svg': token('color.background.accent.orange.subtler'),
	'project_avatar_koala.svg': token('color.background.accent.blue.subtler'),
	'project_avatar_mobile.svg': token('color.background.accent.blue.subtler'),
	'project_avatar_money.svg': token('color.background.accent.orange.subtler'),
	'project_avatar_nature.svg': token('color.background.accent.blue.subtler'),
	'project_avatar_notes.svg': token('color.background.accent.teal.subtler'),
	'project_avatar_flag.svg': token('color.background.accent.orange.subtler'),
	'project_avatar_parrot.svg': token('color.background.accent.purple.subtler'),
	'project_avatar_plane.svg': token('color.background.accent.teal.subtler'),
	'project_avatar_power.svg': token('color.background.accent.teal.subtler'),
	'project_avatar_refresh.svg': token('color.background.accent.purple.subtler'),
	'project_avatar_rocket.svg': token('color.background.neutral'),
	'project_avatar_science.svg': token('color.background.accent.purple.subtler'),
	'project_avatar_settings.svg': token('color.background.accent.red.subtler'),
	'project_avatar_spanner.svg': token('color.background.accent.red.subtler'),
	'project_avatar_storm.svg': token('color.background.accent.purple.subtler'),
	'project_avatar_support.svg': token('color.background.accent.teal.subtler'),
	'project_avatar_website.svg': token('color.background.accent.red.subtler'),
	'project_avatar_yeti.svg': token('color.background.accent.blue.subtler'),
	default: token('color.background.neutral'),
} as const;

type ColorOrAvatarMapping = {
	[projectKey: string]: string;
};

export const useFetchProjectColor = (data: Project[]) => {
	const [colorMapping, setColorMapping] = useState<ColorOrAvatarMapping>({});
	const requestURI = useMemo(() => {
		const queryParams = data.map(({ key: projectKey }) => `project=${projectKey}`).join('&');
		return `/rest/internal/2/projectAvatarNames?${queryParams}`;
	}, [data]);

	useEffect(() => {
		(async () => {
			try {
				const response = await fetchJson<ColorOrAvatarMapping>(requestURI);
				if (!response || !Object.keys(response).length) {
					setColorMapping({});
				}
				setColorMapping(
					// eslint-disable-next-line @typescript-eslint/no-explicit-any
					Object.keys(response).reduce<Record<string, any>>(
						(acc, key) => ({
							// eslint-disable-next-line jira/js/no-reduce-accumulator-spread
							...acc,
							// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly 'project_avatar_alien.svg': "var(--ds-background-accent-teal-subtler)"; readonly 'project_avatar_cloud.svg': "var(--ds-background-accent-blue-subtler)"; readonly 'project_avatar_code.svg': "var(--ds-background-accent-red-subtler)"; ... 23 more ...; readonly default: "var(--ds-background-neutral)"; }'.
							[key]: mappings[response[key]],
						}),
						{},
					),
				);
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (fetchError: any) {
				trackFetchErrors({
					error: fetchError,
					id: 'fetchProjectColor',

					packageName: 'deepDiveCards',
				});
			}
		})();
	}, [requestURI]);

	return colorMapping;
};
